import { isReference } from '@apollo/client';
import { mainBackendApolloCache } from '@coverright/data-access/apollo-clients';

export function getTabIndex() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('tab')) {
    if (urlParams.get('tab') === 'drugs') {
      return 1;
    } else if (urlParams.get('tab') === 'pharmacy') {
      return 2;
    }
  }
  return 0;
}

export const removePlansFromApolloCache = () => {
  mainBackendApolloCache.modify({
    id: 'ROOT_QUERY',
    fields(cached, { DELETE, readField }) {
      if (['PageablePlanOutput', 'PageablePdpPlanOutput'].includes(cached['__typename'])) {
        return DELETE;
      }
      if (isReference(cached) && readField('__typename', cached) === 'Plan') {
        return DELETE;
      }
      if (Array.isArray(cached) && cached.some(item => isReference(item) && readField('__typename', item) === 'Plan')) {
        return DELETE;
      }
      return cached;
    },
  });
  mainBackendApolloCache.gc();
};
